module.exports = __webpack_public_path__ + "static/media/11756645_969814159706673_1762922507_n.d9f03a04.jpg";